<template>
    <div>
        <h1>Minnesota Nurse Aide Registry Search</h1>
        <div class="card">
            <div class="card-body">
                <h2 class="card-title">Search Minnesota Nurse Aide Registry:</h2>
                <div>
                    Registry may be searched by either the combination of first and last name, or by certificate number.
                    For more accurate result, search by "Certificate Number".
                </div>
                <b-row>
                    <b-col>
                        <form-summary :validator="$v.screen" ref="nameErrorContainer" id="nameErrorContainer"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="4" md="4" id="lastNameDiv">
                        <BaseTextInput v-model="search.lastName"
                                       :v="$v.search.lastName"
                                       label="Last Name"
                                       slug="lastName"
                                       setId="lastName"/>
                    </b-col>
                    <b-col cols="4" md="4" id="firstNameDiv">
                        <BaseTextInput v-model="search.firstName"
                                       :v="$v.search.firstName"
                                       label="First Name"
                                       slug="firstName"
                                       setId="firstName"/>
                    </b-col>
<!--                </b-row>-->
<!--                <b-row>-->
<!--                    <b-col cols="4" md="4" id="ssnDiv">-->
<!--                        <BaseMaskedTextInput v-model="search.ssn"-->
<!--                                             :v="$v.search.ssn"-->
<!--                                             slug="ssn"-->
<!--                                             label="Social Security Number"-->
<!--                                             setId="ssn"-->
<!--                                             mask="####"-->
<!--                                             tip="Social Security Number – Last 4 (xxxx)"-->
<!--                        />-->
<!--                    </b-col>-->
                    <b-col cols="4" md="4" id="dobDiv">
                        <BaseDateOfBirthInput v-model="search.dob"
                                              :v="$v.search.dob"
                                              label="Date of Birth"
                                              :messages="dobMessages"
                                              slug="dob"
                                              setId="dob"
                                              tip="Format: MM/DD/YYYY"
                        />
                    </b-col>
                </b-row>
                <hr>
                <b-row>
                    <b-col cols="4" md="4" id="numberDiv">
                        <BaseTextInput v-model="search.number"
                                       :v="$v.search.number"
                                       label="Certificate Number"
                                       slug="number"
                                       setId="number"/>
                    </b-col>
                </b-row>
                <div v-if="isAdmin() || isReadonly()">
                    <b-row>
                        <b-col cols="4">
                            <BaseMaskedTextInput v-model="search.fullSSN"
                                           :v="$v.search.fullSSN"
                                           label="Full SSN"
                                           mask="###-##-####"
                                           slug="fullSSN"
                                           setId="fullSSN"
                                           tip="Social Security Number - 9 digits"/>
                        </b-col>
                    </b-row>
                </div>
                <b-row>
                    <b-col>
                        <BaseSelector v-model="search.profession"
                                      :v="$v.search.profession"
                                      label="Profession"
                                      slug="professionSelect"
                                      :options="opts.professions"
                                      setId="professionSelect"
                                      textField="description"
                                      valueField="code"
                                      @input="filterCertificateTypes(search.profession)"
                        />
                    </b-col>
                    <b-col>
                        <BaseSelector v-model="search.certificateType"
                                    :v="$v.search.certificateType"
                                    label="Certificate Type"
                                    slug="certificateSelect"
                                    :options="opts.certificateTypes"
                                    setId="certificateSelect"
                                    textField="description"
                                    valueField="code"
                                    :plaintext="this.opts.certificateTypes.length === 0"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="1">
                        <b-button type="button" variant="primary" @click="searchCertificates">Search</b-button>
                    </b-col>
                    <b-col cols="1">
                        <b-button type="button" variant="secondary" @click="clearSearch">Clear</b-button>
                    </b-col>
                </b-row>
                <div class="pt-3" v-if="submitted">
                    <b-row>
                        <b-col>
                            <h2>Results</h2>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div v-if="!isLoading">Your search found {{totalRows}} {{totalRows===1?'record':'records'}}</div>
                        </b-col>
                    </b-row>
                  <b-row>
                    <b-col>
                      <b-pagination
                          v-if="totalRows>10"
                          v-model="searchPagination.page"
                          :per-page="perPage"
                          :total-rows="totalRows"
                          align="fill"
                          size="sm"
                          class="my-0"
                          @input="switchPage()"
                      ></b-pagination>
                    </b-col>
                  </b-row>
                    <br/>
                  <div v-if="!isLoading && !isChangingPage">
                        <div v-for="(certificate, index) in certificates" :key="index">
                            <div class="card">
                                <div class="card-header">Record {{(index+1)+10*(searchPagination.page-1)}} of {{totalRows}}</div>
                                <div class="card-body">
                                    <b-row>
                                        <b-col cols="4">
                                            <BaseTextOutput label="Full Name" :value="certificate.name"/>
                                        </b-col>
                                        <b-col cols="4">
                                            <BaseTextOutput label="Certificate Number" :value="certificate.number"/>
                                            <button class="btn btn-primary" v-if="isAdmin() && certificate.number==null" @click="generateNumber(certificate.id)">Generate certificate number</button>
                                        </b-col>
                                        <b-col cols="4">
                                            <BaseTextOutput label="Status" :value="certificate.status"/>
                                        </b-col>
                                    </b-row>
                                  <b-row v-if="isAdmin()">
                                    <b-col cols="12">
                                      <strong>Associated user account: </strong>
                                      <a v-if=certificate.idmId :href="'/viewUser/'+certificate.idmId" target="_blank" class="btn btn-primary btn-sm">View</a>
                                      <span v-else>No user account associated with this certificate</span>
                                    </b-col>
                                  </b-row>
                                    <b-row>
                                        <b-col cols="12">
                                            <BaseTextOutput label="Complaints" :value="certificate.complaint"/>
                                        </b-col>
                                    </b-row>
                                  <b-row v-if="isAdmin()">
                                    <b-col cols="12">
                                      <b-button variant="primary" class="mt-2r" @click="showComplaintModal(certificate)">Change complaint status</b-button>
                                    </b-col>
                                  </b-row>
                                    <b-row>
                                        <b-col cols="4">
                                            <BaseTextOutput label="Date Registered" :value="formatDate(certificate.approvedDate)"/>
                                        </b-col>
                                        <b-col cols="4" v-if="certificate.status === 'Inactive'">
                                            <BaseTextOutput label="Inactive Date" :value="formatDate(certificate.expireDate)"/>
                                        </b-col>
                                        <b-col cols="4" v-if="certificate.status !== 'Inactive'">
                                          <BaseTextOutput label="Expiration Date" :value="formatDate(certificate.expireDate)"/>
                                         </b-col>
                                        <b-col cols="4">
                                            <BaseTextOutput label="Initial Date Registered" :value="formatDate(certificate.initialRegistryDate)"/>
                                        </b-col>
                                    </b-row>
                                  <b-row v-if="isAdmin()">
                                    <b-col>
                                      <b-button variant="primary" class="mt-2" @click="showExpDateModal(certificate)">Change expiration date</b-button>
                                    </b-col>
                                    <b-col>
                                      <b-button variant="primary" class="mt-2" @click="showHMModal(certificate)">Manually insert HM data</b-button>
                                    </b-col>
                                  </b-row>
                                    <b-row>
                                        <b-col cols="3">
                                            <BaseTextOutput label="Most Recent Testing Date: Skill" :value="formatDate(certificate.skillTestDate)"/>
                                        </b-col>
                                        <b-col cols="3">
                                            <BaseTextOutput label="Most Recent Testing Date: Knowledge" :value="formatDate(certificate.knowledgeTestDate)"/>
                                        </b-col>
                                        <b-col cols="3">
                                            <BaseTextOutput label="Last Training Date*" :value="formatDate(certificate.trainingDate)"/>
                                        </b-col>
                                        <b-col cols="3">
                                            <BaseTextOutput label="Test-out Candidate Only" :value="certificate.testOut"/>
                                        </b-col>
                                    </b-row>
                                    <b-row>

                                    </b-row>
                                    <b-row>
                                        <b-col cols="6">
                                            <div>* All approved MN nurse aide training programs are a minimum of 75 hours in length.</div>
                                        </b-col>
                                        <b-col cols="6" v-if="isAdmin()">
                                            <BaseCheckboxInput label="Mark as Confidential.  This will hide the address of the CNA for all non-MDH users."
                                                               v-model="confidential"
                                                               :v="$v.confidential"
                                                               slug="confidential"
                                                               @change="updateConfidential(certificate)"
                                            />
                                        </b-col>
                                    </b-row>
                                    <div v-if="isAdmin() || isReadonly()">
                                      <b-row class="mt-2">
                                        <b-col cols="12">
                                          <h3>Internal MDH Notes</h3>
                                          <b-table hover small show-empty class="sr-caption"
                                                   aria-live="polite"
                                                   responsive="true"
                                                   :fields="noteFieldsInternal"
                                                   :items="certificate.internalNotes"
                                                   :busy="false"
                                                   label-sort-asc=""
                                                   label-sort-desc=""
                                                   caption="Notes table.  To sort the data in this table by a specific column,
                                go to the appropriate column header cell and use enter to sort the data ascending.
                                Use enter again to sort descending.">
                                            <template v-slot:no-data>
                                              No Notes Found.
                                            </template>
                                            <div slot="table-busy" class="text-center text-danger my-2">
                                              <b-spinner class="align-middle" label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
                                              <strong>Loading...</strong>
                                            </div>
                                            <template slot="empty" slot-scope="scope">
                                              No Notes Found.
                                            </template>
                                            <template v-slot:cell(note)="row">
                                              <div style="white-space: pre-line">{{row.item.note}}</div>
                                            </template>
                                            <template v-slot:cell(noteDate)="row">
                                              {{formatDateTime(row.item.noteDate)}}
                                            </template>
                                          </b-table>
                                        </b-col>
                                      </b-row>
                                        <b-row>
                                            <b-col><h2>Employment History</h2></b-col>
                                        </b-row>
                                        <b-row>
                                            <b-table hover small show-empty class="sr-caption" style="width: 100%"
                                                 aria-live="polite"
                                                 responsive="true"
                                                 :fields="fields"
                                                 :items="certificate.employers"
                                                 :busy="isLoading"
                                                  :sort-by.sync="sortBy"
                                                  :sort-desc.sync="sortDesc"
                                                 caption="Search Employer History table.  To sort the data in this table by a specific column,
                                                        go to the appropriate column header cell and use enter to sort the data ascending.
                                                        Use enter again to sort descending.">
                                                <template v-slot:no-data>
                                                    No Employment History Found.
                                                </template>
                                               <template v-slot:cell(applicationDate)="row">
                                                 {{formatDate(row.item.applicationDate)}}
                                               </template>
                                                <template v-slot:cell(startDate)="row">
                                                    {{formatDate(row.item.startDate)}}
                                                </template>
                                                <template v-slot:cell(endDate)="row">
                                                    {{formatDate(row.item.endDate)}}
                                                </template>
                                            </b-table>
                                        </b-row>
                                        <b-row>
                                            <b-col><h2>Applications</h2></b-col>
                                        </b-row>
                                        <b-row>
                                            <b-table hover small show-empty class="sr-caption" style="width: 100%"
                                                     aria-live="polite"
                                                     responsive="true"
                                                     :fields="appFields"
                                                     :items="certificate.applications"
                                                     :busy="isLoading"
                                                     :sort-by.sync="sortBy"
                                                     :sort-desc.sync="sortDesc"
                                                     caption="Search Applications table.  To sort the data in this table by a specific column,
                                                        go to the appropriate column header cell and use enter to sort the data ascending.
                                                        Use enter again to sort descending.">
                                                <template v-slot:no-data>
                                                    No Applications Found.
                                                </template>
                                                <template v-slot:cell(startDate)="row">
                                                    {{formatDate(row.item.submittedDate)}}

                                                </template>
                                                <template v-slot:cell(approvedDate)="row">
                                                    {{formatDate(row.item.approvedDate)}}
                                                </template>
                                                <template v-slot:cell(expirationDate)="row">
                                                    {{formatDate(row.item.expirationDate)}}
                                                </template>
                                                <template v-slot:cell(actions)="row">
                                                    <b-button size="sm" :href="'/review-'+(row.item.type.code==='I'?'endorsement/':'renewal/')+row.item.id"
                                                              variant="primary"
                                                              class="mr-1">View</b-button>
                                                </template>
                                            </b-table>
                                        </b-row>
                                        <b-row>
                                          <b-col>
                                            <h2>Processed Change Requests</h2>
                                          </b-col>
                                        </b-row>
                                        <b-row>
                                          <b-col>
                                            <h3>Name Changes</h3>
                                          </b-col>
                                        </b-row>
                                        <b-row>
                                          <b-table hover small show-empty class="sr-caption" style="width: 100%"
                                                   aria-live="polite"
                                                   responsive="true"
                                                   :fields="nameChangeFields"
                                                   :items="certificate.nameChangeRequests"
                                                   :busy="isLoading"
                                                   :sort-by.sync="sortBy"
                                                   :sort-desc.sync="sortDesc"
                                                   caption="Name change request table. To sort the data in this table by a specific column,
                                                          go to the appropriate column header cell and use enter to sort the data ascending.
                                                          Use enter again to sort descending.">
                                            <template v-slot:no-data>
                                              No name changes found.
                                            </template>
                                            <template v-slot:cell(actions)="row">
                                              <b-button class="sm" variant="primary" target="_blank" :href="'/review-change/name/'+row.item.id+'/'+row.item.profileId">
                                                View
                                              </b-button>
                                            </template>
                                          </b-table>
                                        </b-row>

                                      <b-row>
                                        <b-col>
                                          <h3>DOB Changes</h3>
                                        </b-col>
                                      </b-row>
                                      <b-row>
                                        <b-table hover small show-empty class="sr-caption" style="width: 100%"
                                                 aria-live="polite"
                                                 responsive="true"
                                                 :fields="dobChangeFields"
                                                 :items="certificate.dobChangeRequests"
                                                 :busy="isLoading"
                                                 :sort-by.sync="sortBy"
                                                 :sort-desc.sync="sortDesc"
                                                 caption="Name change request table. To sort the data in this table by a specific column,
                                                          go to the appropriate column header cell and use enter to sort the data ascending.
                                                          Use enter again to sort descending.">
                                          <template v-slot:no-data>
                                            No name changes found.
                                          </template>
                                          <template v-slot:cell(actions)="row">
                                            <b-button class="sm" variant="primary" target="_blank" :href="'/review-change/dob/'+row.item.id+'/'+row.item.profileId">
                                              View
                                            </b-button>
                                          </template>
                                        </b-table>
                                      </b-row>

                                      <b-row>
                                        <b-col>
                                          <h3>SSN Changes</h3>
                                        </b-col>
                                      </b-row>
                                      <b-row>
                                        <b-table hover small show-empty class="sr-caption" style="width: 100%"
                                                 aria-live="polite"
                                                 responsive="true"
                                                 :fields="ssnChangeFields"
                                                 :items="certificate.ssnChangeRequests"
                                                 :busy="isLoading"
                                                 :sort-by.sync="sortBy"
                                                 :sort-desc.sync="sortDesc"
                                                 caption="Name change request table. To sort the data in this table by a specific column,
                                                          go to the appropriate column header cell and use enter to sort the data ascending.
                                                          Use enter again to sort descending.">
                                          <template v-slot:no-data>
                                            No name changes found.
                                          </template>
                                          <template v-slot:cell(actions)="row">
                                            <b-button class="sm" variant="primary" target="_blank" :href="'/review-change/ssn/'+row.item.id+'/'+row.item.profileId">
                                              View
                                            </b-button>
                                          </template>
                                        </b-table>
                                      </b-row>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                  <div>
                    <b-pagination
                        v-if="totalRows>10"
                      v-model="searchPagination.page"
                      :per-page="perPage"
                      :total-rows="totalRows"
                      align="fill"
                      size="sm"
                      class="my-0"
                      @input="switchPage()"></b-pagination>
                    <b-row v-if="!isLoading && submitted">
                      <b-col>
                        This information is valid as of: {{timestamp}}. The certificate data on this website is provided and controlled by the Minnesota Department of Health, Health Regulation Division. Certificate information is updated as changes to status occur, is secure and considered primary source for verification of a Minnesota Nurse Aide certificate.
                      </b-col>
                    </b-row>
                    <b-row v-if="nameSearch">
                      <b-col>
                        <div class="text-danger">
                          This search result was conducted by First Name and Last Name only.<br/>
                          For more accurate result, search by "Certificate Number".
                        </div>
                      </b-col>
                    </b-row>
                    <b-row v-else-if="certNumberSearch">
                      <b-col>
                        <div class="text-danger">
                          This search result was conducted by Certificate Number.
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </div>
            </div>
        </div>
      <b-modal id="expDateChangeModal" hide-header hide-footer @close="cleanUpExpDateModal">
        <h2>Change Expiration Date</h2>
        <hr/>
        <b-row v-if="currentCertificate">
          <b-col cols="4">
            <BaseTextOutput label="Name" :value="currentCertificate.name"/>
          </b-col>
          <b-col cols="3">
            <BaseTextOutput label="Certificate #" :value="currentCertificate.number"/>
          </b-col>
          <b-col cols="3">
            <BaseTextOutput label="Expiration Date" :value="currentCertificate.expireDate"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <BaseDateOfBirthInput label="New Expiration Date" v-model="newExpDate" :v="$v.newExpDate" @input="expDateInPastCheck"/>
          </b-col>
        </b-row>
        <b-row v-if="newExpDate">
          <p class="text-muted" v-if="newExpDateInPast">
            Expiration date is in the past. Certificate will {{currentCertificate.status==='Inactive'?'remain':'be set'}} inactive.
          </p>
          <p class="text-muted" v-else>
            Expiration date is in the future. Certificate will {{currentCertificate.status==='Active'?'remain':'be set'}} active.
          </p>
        </b-row>
        <b-row>
          <b-button variant="primary" v-if="newExpDate" @click="submitNewExpDate">Submit</b-button>
          <b-button variant="secondary" @click="hideExpDateModal">Cancel</b-button>
        </b-row>
      </b-modal>
      <b-modal id="manualHMModal" hide-header hide-footer @close="cleanUpHMModal">
        <h2>Manual HM import</h2>
        <hr/>
        <p>Only use this when HM import failed for some reason for an existing NA</p>
        <b-row>
          <b-col>
            <BaseDateOfBirthInput label="Training date" v-model="hm.trainingDate" :v="$v.hm.trainingDate"/>
          </b-col>
          <b-col>
            <BaseDateOfBirthInput label="Knowledge test date" v-model="hm.knowledgeTestDate" :v="$v.hm.trainingDate"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <button class="btn btn-primary" @click="submitManualHM" :disabled="disableManualHMButton">Submit</button>
            <button class="btn btn-secondary" @click="hideHMModal">Cancel</button>
          </b-col>
        </b-row>

      </b-modal>
      <b-modal id="complaintChangeModal" hide-header hide-footer @close="cleanUpComplaintModal">
        <h2>Change complaint status</h2>
        <hr/>
        <b-row v-if="currentCertificate">
          <b-col cols="4">
            <BaseTextOutput label="Name" :value="currentCertificate.name"/>
          </b-col>
          <b-col cols="3">
            <BaseTextOutput label="Certificate #" :value="currentCertificate.number"/>
          </b-col>
          <b-col cols="3">
            <BaseTextOutput label="Complaint Status" :value="currentCertificate.complaint?opts.complaintStatuses.find(c=>c.description === currentCertificate.complaint).code:''"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <BaseSelector label="New Complaint Status"
                          v-model="newComplaintStatus"
                          :v="$v.newComplaintStatus"
                          :options="opts.complaintStatuses"
                          textField="code"
                          valueField="code"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-button variant="primary" v-if="newComplaintStatus" @click="submitNewComplaintStatus">Submit</b-button>
          <b-button variant="secondary" @click="hideComplaintModal">Cancel</b-button>
        </b-row>

      </b-modal>
    </div>
</template>
<script>
    import axios from "axios"
    import axiosRetry from 'axios-retry'
    import {required, requiredIf, minLength, maxLength, numeric} from 'vuelidate/lib/validators'
    import BaseSelector from "@/components/templates/input/BaseSelector";
    import minDate from '@/validators/minDate'
    import maxDate from '@/validators/maxDate'
    import {toastService} from "@/mixins/toastService";
    import BaseTextOutput from "@/components/templates/input/BaseTextOutput";
    import moment from 'moment';
    import BaseDateOfBirthInput from "../components/templates/input/BaseDateOfBirthInput.vue";

    axiosRetry(axios, {
        retries: 3,
        retryDelay: axiosRetry.exponentialDelay
    })

    export default {
        components:{
          BaseDateOfBirthInput,
            BaseSelector,
            BaseTextOutput
        },
        data() {
            return {
                totalRows: 1,
                perPage: 10,
                newExpDateInPast: null,
                newExpDate: null,
                currentCertificate: null,
                nameSearch: null,
                certNumberSearch: null,
                sortBy: '',
                sortDesc: null,
                certificates: [],
                search: {
                    lastName: '',
                    firstName: '',
                    ssn: '',
                    dob: '',
                    number: '',
                    profession: null,
                    certificateType: null,
                    fullSSN:'',
                    page: 1
                },
              searchPagination: {
                lastName: '',
                firstName: '',
                ssn: '',
                dob: '',
                number: '',
                profession: null,
                certificateType: null,
                fullSSN:'',
                page: 1
              },
                submitted: false,
                isLoading: false,
                isChangingPage: false,
                timestamp: null,
                fields: [
                    {key: "applicationDate", label: "Application date", sortable: true},
                    {key: "hfid", label: "HFID", sortable: true},
                    {key: "name", label: "Name", sortable: true},
                    {key:"department", label: "Department", sortable: true},
                    {key: "address.streetAddress", label: "Street Address", sortable: true},
                    {key: "address.city", label:"City",sortable:true},
                    {key:"address.state",label:"State",sortable:true},
                    {key:"address.postalCode", label:"Zip Code", sortable: true},
                    {key: "startDate", label:"Start Date", sortable: true},
                    {key: "endDate", label: "End Date", sortable: true}
                ],
                appFields: [
                    {key: "type.description", label: "Type", sortable: true},
                    {key: "status.description", label: "Status", sortable: true},
                    {key: "submittedDate", label:"Submitted Date", sortable: true},
                    {key: "approvedDate", label: "Approved Date", sortable: true},
                    {key: "expirationDate", label: "Expiration Date", sortable: true},
                    {key: 'actions', label:'Actions', sortable:false}
                ],
                dobMessages: {
                    maxDate: 'Date of Birth cannot be in the future.',
                    minDate: 'Date of Birth must be after 01/01/1900.'
                },
                nameChangeFields: [
                  {key: "firstName", label: "First Name", sortable:true},
                  {key: "lastName", label: "Last Name", sortable: true},
                  {key: "middleName", label: "Middle Name", sortable: true},
                  {key: "changeDate", label: "Change Date", sortable: true},
                  {key: "status", label: "Status", sortable: true},
                  {key: "actions", label: "Actions"}
                ],
                dobChangeFields: [
                  {key: "dateOfBirth", label: "Date of Birth", sortable: true},
                  {key: "changeDate", label: "Change Date", sortable: true},
                  {key: "status", label: "Status", sortable: true},
                  {key: "actions", label: "Actions"}
                ],
                ssnChangeFields: [
                  {key: "ssn", label: "SSN", sortable: true},
                  {key: "changeDate", label: "Change Date", sortable: true},
                  {key: "status", label: "Status", sortable: true},
                  {key: "actions", label: "Actions"}
                ],
              noteFieldsInternal: [
                {key: 'note', label: 'Note',sortable:true},
                {key: 'noteDate',label:'Note Date',sortable:true},
                {key:'noteByName',sortable:true,label:'Note By'},
              ],
                opts: {
                    professions: [],
                    certificateTypes: [],
                    complaintStatuses: []
                },
                confidential: false,
                newComplaintStatus: null,
                disableManualHMButton: false,
                hm: {
                  trainingDate: null,
                  knowledgeTestDate: null,
                },
                hmCertId: null
            }
        },
        mixins: [
            toastService
        ],
        methods: {
            loadOptions() {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/options/professions`, {ignoreHeader: true})
                    .then(response => {
                        this.opts.professions = response.data
                    })
            },
            loadComplaintStatuses(){
              axios.get(`${process.env.VUE_APP_API_BASE_URL}/options/complaints`, {ignoreHeader: true})
                  .then(response => {
                    this.opts.complaintStatuses = response.data;
                  })
            },
            switchPage(){
              this.isChangingPage = true;
              if (this.$keycloak.authenticated) {
                axios.post(`${process.env.VUE_APP_API_BASE_URL}/certificate/search`, this.searchPagination)
                    .then(response => {
                      this.timestamp = moment().format("dddd, MMMM D, YYYY, hh:mm:ss a")
                      this.certificates = response.data.content
                      this.totalRows = response.data.totalElements
                      this.isLoading = false
                      this.isChangingPage = false
                      this.certNumberSearch = this.search.number==null?false:this.search.number.length>0
                      this.nameSearch = (this.search.firstName==null || this.search.lastName==null)?false:(this.search.firstName.length>0&&this.search.lastName.length>0)
                      if(this.isAdmin() || this.isReadonly()){
                        for(let i = 0; i<this.certificates.length;i++){
                          this.certificates[i].employers = this.certificates[i].employers.sort((e1, e2) => {
                            if(!e1.applicationDate){
                              if(!e2.applicationDate){
                                return 0;
                              }
                              return -1;
                            }
                            if(!e2.applicationDate){
                              return 1;
                            }
                            if(e1.applicationDate > e2.applicationDate){
                              return -1;
                            }
                            if(e2.applicationDate > e1.applicationDate){
                              return 1;
                            }
                            return 0;
                          })
                        }
                      }
                    })
              } else {
                axios.post(`${process.env.VUE_APP_API_BASE_URL}/certificate/search`, this.searchPagination, {ignoreHeader: true})
                    .then(response => {
                      this.certificates = response.data.content
                      this.isLoading = false
                      this.isChangingPage = false;
                      this.timestamp = moment().format("dddd, MMMM D, YYYY, hh:mm:ss a")
                      this.certNumberSearch = this.search.number==null?false:this.search.number.length>0
                      this.nameSearch = (this.search.firstName==null || this.search.lastName==null)?false:(this.search.firstName.length>0&&this.search.lastName.length>0)
                      this.totalRows = response.data.totalElements;
                    })
              }
            },
            searchCertificates() {
                this.$v.search.$touch()
                    if(this.$v.$invalid){
                        this.showRootToast("Error", "Missing required fields.", "danger", this.$root)
                        return
                    }
                this.searchPagination = Object.assign({}, this.search)
                this.totalRows = 1;
                this.isLoading = true
                this.submitted = true
                this.nameSearch = false
                this.certNumberSearch = false
                if (this.$keycloak.authenticated) {
                    axios.post(`${process.env.VUE_APP_API_BASE_URL}/certificate/search`, this.search)
                        .then(response => {
                            this.timestamp = moment().format("dddd, MMMM D, YYYY, hh:mm:ss a")
                            this.certificates = response.data.content
                            this.totalRows = response.data.totalElements
                            this.isLoading = false
                            this.certNumberSearch = this.search.number==null?false:this.search.number.length>0
                            this.nameSearch = (this.search.firstName==null || this.search.lastName==null)?false:(this.search.firstName.length>0&&this.search.lastName.length>0)
                            if(this.isAdmin() || this.isReadonly()){
                              for(let i = 0; i<this.certificates.length;i++){
                                this.certificates[i].employers = this.certificates[i].employers.sort((e1, e2) => {
                                  if(!e1.applicationDate){
                                    if(!e2.applicationDate){
                                      return 0;
                                    }
                                    return -1;
                                  }
                                  if(!e2.applicationDate){
                                    return 1;
                                  }
                                  if(e1.applicationDate > e2.applicationDate){
                                    return -1;
                                  }
                                  if(e2.applicationDate > e1.applicationDate){
                                    return 1;
                                  }
                                  return 0;
                                })
                              }
                            }
                        })
                } else {
                    axios.post(`${process.env.VUE_APP_API_BASE_URL}/certificate/search`, this.search, {ignoreHeader: true})
                        .then(response => {
                            this.certificates = response.data.content
                            this.isLoading = false
                            this.timestamp = moment().format("dddd, MMMM D, YYYY, hh:mm:ss a")
                            this.certNumberSearch = this.search.number==null?false:this.search.number.length>0
                            this.nameSearch = (this.search.firstName==null || this.search.lastName==null)?false:(this.search.firstName.length>0&&this.search.lastName.length>0)
                            this.totalRows = response.data.totalElements;
                        })
                }
            },
            clearSearch() {
                this.certificates = []
                this.search = {
                    lastName: '',
                    firstName: '',
                    ssn: '',
                    dob: '',
                    number: '',
                    profession: null,
                    certificateType: null,
                    fullSSN: '',
                    page: 1
                }
                this.totalRows = 1;
                this.$v.$reset()
                this.submitted = false
            },
            isAdmin() {
                if (this.$keycloak && this.$keycloak.authenticated) {
                    return (this.$keycloak.hasResourceRole('mdh-admin') || this.$keycloak.hasResourceRole('mdh-staff')
                        || this.$keycloak.hasResourceRole('mnit-admin'))
                } else {
                    return false;
                }
            },
            isReadonly() {
                if (this.$keycloak && this.$keycloak.authenticated) {
                    return (this.$keycloak.hasResourceRole('readonly'))
                } else {
                    return false;
                }
            },
            filterCertificateTypes(event) {
                if (event !== null ) {
                    var profession = this.opts.professions.filter(p => p.code === event)
                    this.opts.certificateTypes = profession[0].certificateTypes;
                }
                this.search.certificateType = null;
            },
            formatDate(unformattedDate){
                let formattedDate = moment(unformattedDate);
                if(!formattedDate.isValid()) return 'N/A';
                return formattedDate.format("MM/DD/YYYY")
            },
            updateConfidential(certificate) {
                var payload = {
                    number: certificate.number,
                    confidential: this.confidential
                }
                axios.post(`${process.env.VUE_APP_API_BASE_URL}/certificate/confidential`, payload)
                    .then(response => {
                        this.showRootToast("Success", "Updated Confidentiality setting", 'success', this.$root)
                    })
            },
            launchReview(item){
                this.$router.push({path: `/review-renewal/${item.id}`});
            },
            showExpDateModal(item){
              this.newExpDate = null;
              this.currentCertificate = Object.assign({}, item);
              this.$v.$reset();
              this.$bvModal.show('expDateChangeModal');
            },
            hideExpDateModal(){
              this.$bvModal.hide('expDateChangeModal');
              this.cleanUpExpDateModal();
            },
            cleanUpExpDateModal(){
              this.newExpDate = null;
              this.currentCertificate = null;
            },
            showComplaintModal(item){
              this.newComplaintStatus = null;
              this.currentCertificate = Object.assign({},item);
              this.$v.$reset();
              this.$bvModal.show("complaintChangeModal");
            },
            hideComplaintModal(){
              this.$bvModal.hide("complaintChangeModal");
              this.cleanUpComplaintModal();
            },
            cleanUpComplaintModal(){
              this.newComplaintStatus = null;
              this.currentCertificate = null;
            },
            showHMModal(item){
              this.currentCertificate = Object.assign({},item);
              this.$bvModal.show("manualHMModal");
            },
            hideHMModal(){
              this.$bvModal.hide("manualHMModal");
              this.cleanUpHMModal();
            },
            cleanUpHMModal(){
              this.currentCertificate = null;
              this.hm = {
                trainingDate: null,
                knowledgeTestDate: null
              }
              this.disableManualHMButton = false;
            },
            submitManualHM(){
              this.disableManualHMButton = true;
              this.$v.hm.$touch();
              if(this.$v.hm.$invalid){
                this.showRootToast('Invalid dates', 'Training and knowledge test dates cannot be in the future', 'danger', this.$root);
                this.disableManualHMButton = false;
                return;
              }
              if(this.hm.knowledgeTestDate == null || this.hm.knowledgeTestDate == '' || this.hm.trainingDate == null || this.hm.knowledgeTestDate == ''){
                this.showRootToast('Missing dates', 'Training and knowledge test dates are required', 'danger', this.$root);
                this.disableManualHMButton = false;
                return;
              }
              axios.post(`${process.env.VUE_APP_API_BASE_URL}/certificate/manualHMImport/${this.currentCertificate.id}`,this.hm)
                  .then(response => {
                    this.showRootToast('Manual HM import submitted', 'Restart the search to see the update(s)', 'success', this.$root);
                    this.hideHMModal();
                  })
                  .catch(error => {
                    if (error.response.status === 404) {
                      this.showRootToast('Manual HM failed', 'Certificate not found', 'danger', this.$root);
                    } else if (error.response.status === 403) {
                      this.showRootToast('Unauthorized', 'You do not have permissions to perform this action', 'danger', this.$root);
                    } else if (error.response.status === 401) {
                      this.showRootToast('Unauthenticated', 'You are not logged in or your session has expired. Log in as MDH to continue.', 'danger', this.$root);
                    } else {
                      this.showRootToast('Server error.', 'Update failed due to an internal server error. Please let the IT know.', 'danger', this.$root);
                    }
                    this.disableManualHMButton = false;
                  })
            },
          submitNewComplaintStatus(){
              axios.post(`${process.env.VUE_APP_API_BASE_URL}/certificate/update-complaints/${this.currentCertificate.number}`,this.newComplaintStatus)
                  .then(response => {
                    this.showRootToast('Complaint status updated', 'The complaint status for this certificate has been successfully updated.','success',this.$root)
                  })
                  .catch(error=> {
                    if (error.response.status === 404) {
                      this.showRootToast('Complaint status update failed', 'Certificate not found', 'danger', this.$root);
                    } else if (error.response.status === 406) {
                      this.showRootToast('Complaint status update failed', 'Certificate complaint update failed', 'danger', this.$root);
                    } else if (error.response.status === 403) {
                      this.showRootToast('Unauthorized', 'You do not have permissions to perform this action', 'danger', this.root);
                    } else if (error.response.status === 401) {
                      this.showRootToast('Unauthenticated', 'You are not logged in or your session has expired. Log in as MDH to continue.', 'danger', this.$root);
                    } else {
                      this.showRootToast('Server error.', 'Update failed due to an internal server error. Please let the IT know.', 'danger', this.$root);
                    }
                  })
                  .finally(()=>{
                    this.hideComplaintModal();
                  })
          },

          submitNewExpDate(){
              axios.post(`${process.env.VUE_APP_API_BASE_URL}/certificate/update-exp-date/${this.currentCertificate.number}`,this.newExpDate)
                  .then(response=>{
                    this.showRootToast('Expiration date updated','The expiration date for this certificate has been successfully updated.','success',this.$root)
                  })
                  .catch(error=>{
                    if(error.response.status===404){
                      this.showRootToast('Expiration date update failed','Certificate not found','danger',this.$root);
                    }
                    else if(error.response.status===406){
                      this.showRootToast('Expiration date update failed','Certificate has no approved/processed applications to which a new expiration date could be applied','danger',this.$root);
                    }
                    else if(error.response.status===403){
                      this.showRootToast('Unauthorized','You do not have permissions to perform this action','danger',this.root);
                    }
                    else if(error.response.status===401){
                      this.showRootToast('Unauthenticated','You are not logged in or your session has expired. Log in as MDH to continue.','danger',this.$root);
                    }
                    else {
                      this.showRootToast('Server error.','Update failed due to an internal server error. Please let the IT know.','danger',this.$root);
                    }
                  })
                  .finally(()=> {
                    this.hideExpDateModal();
                  })
                },
          expDateInPastCheck(){
            this.newExpDateInPast =  moment(this.newExpDate).isBefore(moment().startOf('day'));
          },
          formatDateTime(noteDateTime){
            return moment(noteDateTime).format('MM/DD/YYYY hh:mmA');
          },
          generateNumber(id){
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/certificate/assignNumber/${id}`)
                .then(response => {
                  this.showRootToast('Number generated', "A new number has been successfully assigned to this certificate");
                })                  .catch(error=>{
              if(error.response.status===404){
                this.showRootToast('Number update failed','Certificate not found','danger',this.$root);
              }
              else if(error.response.status===406){
                this.showRootToast('Number update failed','Certificate has no approved/processed applications','danger',this.$root);
              }
              else if(error.response.status===409){
                this.showRootToast('Number update failed', 'Certificate already has a number assigned to it');
              }
              else if(error.response.status===403){
                this.showRootToast('Unauthorized','You do not have permissions to perform this action','danger',this.root);
              }
              else if(error.response.status===401){
                this.showRootToast('Unauthenticated','You are not logged in or your session has expired. Log in as MDH to continue.','danger',this.$root);
              }
              else {
                this.showRootToast('Server error.','Update failed due to an internal server error. Please let the IT know.','danger',this.$root);
              }
            })
          },
          showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
              title: title,
              toaster: 'b-toaster-top-center',
              solid: true,
              variant: type,
              appendToast: true,
              noAutoHide:true
            })
            this.toastFocus()
          },
          toastFocus() {
            setTimeout(() => {
              let elem = document.getElementsByClassName("toast")
              elem = elem[elem.length-1]
              elem.focus()
            }, 100)
          },
        },
        validations() {
            return {
                newExpDate: {
                  required: requiredIf(function(){
                    return (this.currentCertificate!=null && this.newComplaintStatus == null);
                  })
                },
                newComplaintStatus: {
                  required: requiredIf(function () {
                    return (this.currentCertificate != null && this.newExpDate == null);
                  })
                },

                search: {
                    lastName: {
                        required: requiredIf(function () {
                            return this.search.number.length === 0 && this.search.fullSSN.length === 0 && this.search.firstName.length === 0
                        })
                    },
                    firstName: {
                        required: requiredIf(function () {
                            return this.search.number.length === 0 && this.search.fullSSN.length === 0 && this.search.lastName.length === 0
                        })
                    },
                    // ssn: {
                    //     required: false,
                    //     minLength: minLength(4),
                    //     maxLength: maxLength(4),
                    //     numeric
                    // },
                    dob: {required: false,
                        maxDate: maxDate(new Date()),
                        minDate: minDate(new Date('1900-01-01'))
                    },
                    number: {
                        required: requiredIf(function () {
                            return !(this.search.lastName.length > 0 || this.search.firstName.length > 0 || this.search.ssn.length > 0 || this.search.dob.length > 0) && this.search.fullSSN.length === 0
                        }),
                        numeric
                    },
                    profession: {required: false},
                    certificateType: {required: false},
                    fullSSN:{
                        required: requiredIf(function(){
                            return !(this.search.lastName.length > 0 || this.search.firstName.length > 0 || this.search.ssn.length > 0 || this.search.dob.length > 0) && this.search.number.length === 0
                        })
                    }
                },
                confidential: { required:false },
                hm: {
                  trainingDate: {
                    required: false,
                    maxDate: maxDate(new Date())
                  },
                  knowledgeTestDate: {
                    required: false,
                    maxDate: maxDate(new Date())
                  }
                }
            }
        },
        created() {
            document.title = "Search - NAR"
            this.loadOptions();
            this.loadComplaintStatuses();
        },
    }
</script>
